module.exports = __webpack_public_path__ + "img/copy-colored.770393e6.svg";